var App = App || {};

App.SiteAlerts = (function ($) {
    'use strict';

    function init() {
        $(".site-alerts .site-alert").each(function () {

            var Alert = $(this);
            var Dismiss = Alert.find(".site-alert-dismiss > button");
            var Collapse = Alert.find(".site-alert-collapse > button");

            Dismiss.on("click", function () {
                Alert.slideUp(250);
                var AlertGuid = Alert.data("alertguid");
                App.Cookies.setItem(AlertGuid, "Dismissed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");

                setTimeout(function () {
                    $(window).trigger("scroll");
                    Waypoint.refreshAll();
                }, 250);
            });

            Collapse.on("click", function () {

                var AlertGuid = Alert.data("alertguid");

                if ($(this).attr("aria-expanded") == "false") {
                    $(this).attr("aria-expanded", "true");
                    Alert.removeClass("collapsed").find(".site-alert-content").attr("aria-hidden", "false");
                    Alert.find(".site-alert-content").find("a").attr("tabindex", 0);
                    App.Cookies.setItem(AlertGuid, "Collapsable", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
                }
                else {
                    $(this).attr("aria-expanded", "false");
                    Alert.addClass("collapsed").find(".site-alert-content").attr("aria-hidden", "true");
                    Alert.find(".site-alert-content").find("a").attr("tabindex", -1);
                    App.Cookies.setItem(AlertGuid, "Collapsed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
                }

                setTimeout(function () {
                    $(window).trigger("scroll");
                    Waypoint.refreshAll();
                }, 250);
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteAlerts.init();
});